export default __webpack_public_path__ + "static/media/picture-7.5a6a72a5.png";